import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '~/hooks/useAppSelector';
import { selectIsAdmin, selectAuthStatus } from '~/extensions/Auth/duck/authDuck';
import { selectAdminDashboardEnabled } from '~/slices/featureFlagsSlice';

// Guards the /admin route — only platform admins (is_admin === true) may access,
// and only when the ADMIN_DASHBOARD_ENABLED feature flag is true.
// Deny-first: non-admin is the default state until proven otherwise.
// During loading/idle (refresh in-flight on boot) we render nothing to avoid
// a premature redirect that would send admin users to /workspaces.
export default function AdminRoute() {
  const isAdmin = useAppSelector(selectIsAdmin);
  const adminDashboardEnabled = useAppSelector(selectAdminDashboardEnabled);
  const status = useAppSelector(selectAuthStatus);

  if (status === 'idle' || status === 'loading') return null;
  return isAdmin && adminDashboardEnabled ? <Outlet /> : <Navigate to="/workspaces" replace />;
}
